import type { PrivateEventDetail } from '../../api/privateEvents';

import {
  addOnsNotesPatch,
  seedAddOnsNotes,
  type AddOnsNotesDraft,
} from './private-event-add-ons-notes';
import { useSectionDraft } from './use-section-draft';

export function useAddOnsNotesForm(event: PrivateEventDetail, onDenied: () => void) {
  return useSectionDraft<AddOnsNotesDraft>({
    event,
    seed: seedAddOnsNotes,
    patch: addOnsNotesPatch,
    onDenied,
  });
}

export type AddOnsNotesForm = ReturnType<typeof useAddOnsNotesForm>;
